import ApiService from "../common/apiService";
import { formatDate } from "../common/formatting";
import { LAST_USED_TA_REPORT } from "./actions.type";

const lastUsedTAReportModule = {
  state: {
    lastUsedTaReportUsers: [],
    unusedForMonths: null,
    selectedReportOptions: []
  },
  mutations:{
    lastUsedTaReportUsers(state, data){
      const format = 'DD MMM YYYY';
      for(const e of data) {
        e.name = {
          value: e.first_name + ' ' + e.last_name,
          link: '/admin/user/'+e.id
        };
        e.emailObj = {
          value: e.email,
          link: 'mailto:'+e.email
        };
        e.last_used = {
          value: (e.user_info && e.user_info.last_used)?formatDate(e.user_info.last_used, format):''
        };
        e.reviewed_at = {
          value: (e.user_info && e.user_info.reviewed_at)?formatDate(e.user_info.reviewed_at, format):''
        };
      }
      state.lastUsedTaReportUsers = data;
    },
    unusedForMonths(state, data) {
      state.unusedForMonths = data;
    },
    selectedReportOptions(state, data) {
      state.selectedReportOptions = data;
    }
  },
  getters: {

  },
  actions: {
    [LAST_USED_TA_REPORT](context,payload){
      this.commit('unusedForMonths', payload.unusedForMonths);
      this.commit('selectedReportOptions', payload.selectedReportOptions);
      let options = '';
      payload.selectedReportOptions.map(ele => {
        options += ','+ele.id;
      });
      if(options.length > 0) {
        options = options.substring(1);
      }
      return new Promise((resolve,reject)=>{
           ApiService.get('/admin/ta/unusedtasformonths/'+payload.unusedForMonths+'/'+options)
             .then(({data}) => {
              this.commit('lastUsedTaReportUsers', data);
               resolve(data)
             })
             .catch(({response})=>{
               reject(response);
             })
        }
      );
    }
  },
};

export default lastUsedTAReportModule;
